import React from "react";
import Table from "rc-table";
import * as i18n from "util/i18n";
import { obj } from "prop-types";

const SumaryTable = ({ data }) => {
    const columns = [
        {
            title: i18n.get("creditBill.table.debtor"),
            dataIndex: "buyer",
            key: "buyer",
        },
        {
            title: i18n.get("creditBill.table.emitter"),
            dataIndex: "emitter",
            key: "emitter",
        },
        {
            title: i18n.get("creditBill.table.emission"),
            dataIndex: "emisionDate",
            key: "emisionDate",
        },
        {
            title: i18n.get("creditBill.table.expiration"),
            dataIndex: "expireryDate",
            key: "expireryDate",
        },
        {
            title: i18n.get("creditBill.table.amount"),
            dataIndex: "amount",
            key: "amount",
        },
    ];
    return (
        <div>
            <Table columns={columns} data={data} />
        </div>
    );
};

SumaryTable.propTypes = {
    data: obj,
};

SumaryTable.defaultProps = {
    data: {},
};

export default SumaryTable;
